import { getScoringHistoryExportData } from '../../api/scoringApi';
import { matchClassRoster } from '../../api/classRosterApi';
import { isPlaceholderStudentName } from '../../utils/studentNamePolicy';
import { buildMultiRecordHandoffState, SCORING_HANDOFF_MAX_RECORDS } from './scoringSaenggibuHandoff';

const MATCH_NAME_LIMIT = 300;

const collectNames = (records) => {
  const names = new Set();
  records.forEach(record => (record?.results || []).forEach((result) => {
    const name = String(result?.studentName || result?.student_name || '').trim();
    if (name && !isPlaceholderStudentName(name)) names.add(name);
  }));
  return [...names].slice(0, MATCH_NAME_LIMIT);
};

// 반 명단이 있으면 별칭까지 맞춰 같은 학생으로 묶는다. 명단 조회가 실패해도 이름으로 묶어 계속한다.
const buildCanonicalName = async (records) => {
  const names = collectNames(records);
  if (names.length < 2) return null;
  try {
    const result = await matchClassRoster(names);
    if (!result?.roster) return null;
    const byName = new Map(
      (result.matches || [])
        .filter(match => match.sid && (match.how === 'name' || match.how === 'alias'))
        .map(match => [names[match.index], match.roster_name])
    );
    return name => byName.get(String(name || '').trim()) || null;
  } catch (_error) {
    return null;
  }
};

export const loadMultiRecordHandoff = async (recordIds) => {
  const ids = [...new Set(recordIds || [])].slice(0, SCORING_HANDOFF_MAX_RECORDS);
  if (ids.length === 0) return null;
  const response = await getScoringHistoryExportData(ids);
  const records = Array.isArray(response?.records) ? response.records : [];
  const canonicalName = await buildCanonicalName(records);
  return buildMultiRecordHandoffState(records, { canonicalName });
};
